"use client";
import Link from "next/link";
import React from "react";

interface ContactUsButtonProps {
  className?: string;
}

const ContactUsButton: React.FC<ContactUsButtonProps> = ({ className = "" }) => {
  return (
    <Link href="/contact-us" className="inline-block">
      <button className={`inline-flex items-center justify-center hover:cursor-pointer bg-[linear-gradient(to_right,_#056686,_#8ABA28)] text-white px-6 py-2.5 rounded-full text-[13px] font-medium whitespace-nowrap transition-all duration-300 hover:opacity-90 active:scale-[0.98] ${className}`}>
        Contact us
      </button>
    </Link>
  );
};

export default ContactUsButton;
